// extracted by mini-css-extract-plugin
export default {"menuButton":"PhsKNHJpFmseZIINIfFH","icon":"YepYwuO60gLsBtls7Ws8","active":"CnLBioi9omFk4Mxd61pg","iconWrapper":"c9RqaeTfPMAN5sYpBjfl","notification":"QH7Csl8KhZoiGAFvJx5A"};